export enum SpotlightSearchFilter {
  SHOW_DELETED = 'show_deleted',
  SHOW_CLOSED = 'show_closed',
  ESTATE_ASSIGNED_TO_ME = 'estate_assigned_to_me'
  // CREATED_TODAY = 'created_today',
  // CREATED_IN_LAST_7_DAYS = 'created_in_last_7_days'
}
